import files from 'file-saver'
import api from '@/api'
import {getHeaderName} from '@/utils'
import {
  SET_EXPORTING,
  SET_CGFEENAME,
} from './mutation-types'

const state = {
  exporting: false,
  cgFeeName: [],
}

const mutations = {
  [SET_CGFEENAME] (state, payload) {
    state.cgFeeName = payload
  },
  [SET_EXPORTING] (state, payload) {
    state.exporting = payload
  },
}

const actions = {
  async getSoftwareChargeList ({commit, state}, payload) {
    const {data} = await api.deployApi.getCgFeeList(payload)
    return data
  },
  async getCgFeeName ({commit, state}, payload) {
    const {data} = await api.deployApi.getCgFeeName(payload)
    commit(SET_CGFEENAME, data)
  },
  async addCharge ({state}, payload) {
    const data = await api.deployApi.addCgFee(payload)
    return data
  },
  async dealCharge ({state}, payload) {
    const data = await api.deployApi.editCgFee(payload)
    return data
  },
  async deleteCharge ({state}, payload) {
    const data = await api.deployApi.deleteCgFee(payload)
    return data
  },
  async exportChargeExcel ({commit}, payload) {
    try {
      const {data, headers} = await api.deployApi.exportChargeDataExcel(payload)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
